import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import type { AsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { stat } from 'fs'
import moment from 'moment'
import { act } from 'react-dom/test-utils'
import { ThunkHttpClient } from '../utils/httpThunkClient'
import dayjs from 'dayjs'


const initialStatedatadefault = {
    "data": [
        {
            "created": null,
            "createdBy": null,
            "updated": null,
            "updatedBy": null,
            "companyId": null,
            "id": null,
            "BookingNames": null,
            "bookingAirTicketInfo": [
                {
                    "created": null,
                    "createdBy": null,
                    "updated": null,
                    "updatedBy": null,
                    "companyId": null, 
                    "id": null,
                    "booking": null,
                    "bookingAirTicketPassengersInfo": null,
                    "isRoundTrip": null,
                    "supplierId": null,
                    "flyerId": null,
                    "fromAirportId": null,
                    "toAirportId": null,
                    "departureDate": null,
                    "arrivalDate": null,
                    "arrivalFlightNumber": null,
                    "departureFlightNumber": null,
                    "adultCount": 0,
                    "childCount": 0,
                    "infantCount": 0,
                    "adultCost": 0.0,
                    "childCost": 0.0,
                    "infantCost": 0.0,
                    "adultSellingPrice": 0.0,
                    "childSellingPrice": 0.0,
                    "infantSellingPrice": 0.0,
                    "remark": null
                }
            ],
            "bookingHotelInfo": [
                
            ],
            "bookingHotelOth": [
                {
                    "created": null,
                    "createdBy": null,
                    "updated": null,
                    "updatedBy": null,
                    "companyId": null,
                    "id": null,
                    "booking": null,
                    "hotelId": null,
                    "checkinDate": null,
                    "checkoutDate": null,
                    "roomType": null,
                    "totalRoom": 0
                }
            ],
            "bookingInsuranceInfo": [
                {
                    "created": null,
                    "createdBy": null,
                    "updated": null,
                    "updatedBy": null,
                    "companyId": null,
                    "id": null,
                    "booking": null,
                    "insuranceType": null,
                    "travelDate": null,
                    "name": null,
                    "sex": null,
                    "passportNumber": null,
                    "nationalityId": null,
                    "birthDate": null,
                    "price": null
                }
            ],
            "bookingInternationalVisaInfo": [
                {
                    "created": null,
                    "createdBy": null,
                    "updated": null,
                    "updatedBy": null,
                    "companyId": null,
                    "id": null,
                    "booking": null,
                    "travelDate": null,
                    "name": null,
                    "sex": null,
                    "passportNumber": null,
                    "nationalityId": null,
                    "internationalVisaType": null,
                    "price": null
                }
            ],
            "bookingOTBServiceInfo": [
                {
                    "created": null,
                    "createdBy": null,
                    "updated": null,
                    "updatedBy": null,
                    "companyId": null,
                    "id": null,
                    "booking": null,
                    "otbType": null,
                    "travelDate": null,
                    "name": null,
                    "passportNumber": null,
                    "nationalityId": null,
                    "visaType": null,
                    "price": null,
                    "pnr": null
                }
            ],
            "bookingTourInfoEntity": [
                {
                    "created": null,
                    "createdBy": null,
                    "updated": null,
                    "updatedBy": null,
                    "companyId": null,
                    "id": null,
                    "booking": null,
                    "city": null,
                    "bookingType": null,
                    "tourId": null,
                    "tourDate": null,
                    "tourTime": null,
                    "adultCount": 0,
                    "childCount": 0,
                    "infantCount": 0,
                    "remark": null
                }
            ],
            "bookingOnlineTourInfoEntity": [
                {
                    "created": null,
                    "createdBy": null,
                    "updated": null,
                    "updatedBy": null,
                    "companyId": null,
                    "id": null,
                    "booking": null,
                    "cityId": null,
                    "tourGroupId": null,
                    "tourId": null,
                    "date": null,
                    "time": null,
                    "adultCount": 0,
                    "childCount": 0,
                    "infantCount": 0,
                    "remark": null
                }
            ],
            "bookingNames": null
        }
    ],
    "status": "ok",
    "error": null
}
var cusd = {
    tour: [],
    bookingDetail: {
        gendguestNamePrefix: 'Mr.',
        phoneNumberPrefix: '+971',
        whatsappNumberPrefix:  '+971',
        country: 'DubaiUnited Arab Emirates'
    },
    customer1: {
        // businessFrom :25,
        // profitCenter :110,
        // businessProvider :7,
        // teamMember :"Team Member 2",
        // residenceType :"Hotel",
        // prefix :"86",
        // guestName :"Mamta",
        // Email :"mamtadevi@gmail.com",
        // phoneNumber :1231121212,
        // whatsapp :12121212,
        // country :"Argentina",
        // city :"Ajman",
        // hotelContactNumber :11212,
        // vip :"11212",
        // idNumber :"124",
        // company :"Sdj",
        // designation :"Java",
        // hotelName :"Aran hotel",
        // hotelAddress :"shjsdfj sdf ASd",
        // hotelRoomNumber :"12A",
        // postalCode :"302012"
    }
  }



// // First, create the thunk
// // Define a type for the slice state
// export const bookingsliceProductSearch = ThunkHttpClient.get('bookingslice/search',
//     (data) => ("itinerary/productList?pageSize=1&pageNo=1") )


export const boolkingFetchList = ThunkHttpClient.get('bookingslice/listofbooking',
    () => ("booking/list") )

export const boolkingFetchGuestAutoSuggest = ThunkHttpClient.get('bookingslice/boolkingFetchGuestAutoSuggest',
    (guest) => ("booking/guest?guestname="+guest) )

export const fetchBoolkingFetchBusinessProviderByProfitCenter = ThunkHttpClient.get('bookingslice/businessProvider/fetchByProfitCenterId',
    (profitCenterId) => ("master/fetchByProfitCenterId/"+profitCenterId) )




export const dynamicGatway = ThunkHttpClient.post('bookingslice/dddffd', (data) => ({ url: "gateway/AtTheTop/Booking/GetProducts", body:  {}}) )

// export const itineraryFetchHotelByName = ThunkHttpClient.get('bookingslice/itineraryFetchHotelByName',
//     (data) => ("itinerary/searchHotel?name="+data))

// export const itineraryPreview = ThunkHttpClient.get('bookingslice/itineraryFetchHotelByName',
//     (data) => ("itinerary/previewQuotation?quotation_id="+data))

// export const itinerarySaveHotel = ThunkHttpClient.post('bookingslice/itinerarySaveHotel',
//     (data) => ({ url: "itinerary/saveHotel", body:  data}))

//     export const itinerarySaveQuotationDetail = ThunkHttpClient.post('bookingslice/saveQuotation',
//     ({customerid, sendToEmail, body}) => { return { url: "itinerary/saveQuotation?customerId="+customerid+"&sendToEmail="+sendToEmail, body:  body} })

//     export const itinerarySaveCustomerDetail = ThunkHttpClient.post('bookingslice/savitinerarySaveCustomerDetaileQuotation',
//     (body) => { return { url: "itinerary/saveCustomer", body:  body} })

//     export const itinerarysendQuotationToEmail = ThunkHttpClient.get('bookingslice/savitinerarysendQuotationToEmaileQuotation',
//     (body) => "itinerary/sendQuotationToEmail?quotation_id="+body)

//     export const itineraryDeleteProduct = ThunkHttpClient.delete('bookingslice/savitinerarysendQuotationToProductDelete',
//     (id) => "itinerary/deleteHotel?id="+id)

//     export const itineraryDeleteHotel = ThunkHttpClient.delete('bookingslice/savitinerarysendQuotationToHotelDeete',
//     (id) => "itinerary/deleteProduct?id="+id)

    export const saveBookingDraft = ThunkHttpClient.post('bookingslice/savedraftbooking',
    (data) => { return { url: "booking", body:  data} })  
    
    export const updateBooking = ThunkHttpClient.put('bookingslice/updatebooking',
    ({id, data}) => { return { url: "booking/" + id, body:  data} })
    
    export const getBookingDraft  = ThunkHttpClient.get('bookingslice/getbookingdraft',
     ()  =>  "booking/draft")

    export const getBookingDraftById  = ThunkHttpClient.get('bookingslice/getbookingdraftbyid',
      (id)   =>  "booking/"+id)
    

// Define the initial state using that type
const initialState: any = {
    createbookinguiform: cusd
}

export const bookingSlice = createSlice({
    name: 'booking',
    //deep clone initialState
    initialState: JSON.parse(JSON.stringify(initialState)),
    reducers: {
        createbookinguiformupdate: (state, action) => {
            if (action.payload.form === 'all') {
                // Update all form data at once
                state.createbookinguiform = { ...action.payload.data }
                
            } else {
                state.createbookinguiform[action.payload.form] = action.payload.data
            }
            return state
          },
        createbookinguiformreset: (state, action) => {
            state.createbookinguiform[action.payload.form] = {}
            return state
        },
        submitformdata: (state, action) => {
            const key = 'list'+action.payload.form;
            const ob = action.payload.data;
            let array = state.createbookinguiform[key] || [];
            console.log(array, ob, "datataaaaa")
            array = array.filter((e:any) => {
                if(ob.idunique && ob.idunique+'' === e.idunique+''){
                    return false
                }
                
                if(ob.id &&  ob.id+'' === e.id+''){
                    return false
                }
                return true
        })
             array.push({...ob, idunique: ob.idunique || new Date().getTime().toString()})
             state.createbookinguiform[key] = array;
            const nkv = JSON.parse(JSON.stringify(ob));
            Object.keys(nkv).forEach(key => {
                nkv[key] = undefined;
                });
            state.createbookinguiform[action.payload.form]=nkv
            return state
        },
        removefromlist: (state, action) => {
            state.createbookinguiform['list'+action.payload.form] = state.createbookinguiform['list'+action.payload.form].filter((e:any) => e.idunique !== action.payload.data.idunique)
            return state
        },
        completeReset: (state, action) => {
            state.createbookinguiform = JSON.parse(JSON.stringify(initialState.createbookinguiform))
            return state
        },

        bookingListSearch: (state, action) => {
            state.bookingListSearchState = action.payload
            return state
        }
    },
    extraReducers: (builder) => {
    
        builder.addCase(boolkingFetchList.fulfilled, (state, action) => {
            state.bookingListloading = false;
            state.bookingListData = action.payload
        })
        builder.addCase(boolkingFetchList.pending, (state, action) => {
            state.bookingListloading = true;
        })
        builder.addCase(boolkingFetchList.rejected, (state, action) => {
            state.bookingListloading = false;
        })

        builder.addCase(saveBookingDraft.fulfilled, (state, action) => {
            state.saveDraftloading = false;
            state.saveDraftResponse = action.payload;
        });
        builder.addCase(saveBookingDraft.pending, (state, action) => {
            state.saveDraftloading = true;
        });
        builder.addCase(saveBookingDraft.rejected, (state, action) => {
            state.saveDraftloading = true;
            state.saveDraftError = action.error;
        });

        builder.addCase(updateBooking.fulfilled, (state, action) => {
            state.updateBookingloading = false;
            state.updateBookingResponse = action.payload;
        });
        builder.addCase(updateBooking.pending, (state, action) => {
            state.updateBookingloading = true;
        });
        builder.addCase(updateBooking.rejected, (state, action) => {
            state.updateBookingloading = true;
            state.updateBookingError = action.error;
        });

       builder.addCase(getBookingDraft.fulfilled, (state, action) => {
            state.getDraftStatus = 'succeeded';
            state.getDraftResponse = action.payload;
         });
        builder.addCase(getBookingDraft.pending, (state, action) => {
            state.getDraftStatus = 'loading';
         });
        builder.addCase(getBookingDraft.rejected, (state, action) => {
            state.getDraftStatus = 'failed';
            state.getDraftError = action.error;
        });
        builder.addCase(getBookingDraftById.fulfilled, (state, action) => {
            state.getDraftStatus = 'succeeded';
            state.getDraftResponse = action.payload;
          });
        builder.addCase(getBookingDraftById.pending, (state, action) => {
            state.getDraftStatus = 'loading';   
            });
        builder.addCase(getBookingDraftById.rejected, (state, action) => {
            state.getDraftStatus = 'failed';
            state.getDraftError = action.error;
        });

        builder.addCase(boolkingFetchGuestAutoSuggest.fulfilled, (state, action) => {
            state.boolkingFetchGuestAutoSuggestLoading = 'succeeded';
            state.boolkingFetchGuestAutoSuggestData = action.payload.data;
          });
        builder.addCase(boolkingFetchGuestAutoSuggest.pending, (state, action) => {
            state.boolkingFetchGuestAutoSuggestLoading = 'loading';   
            });
        builder.addCase(boolkingFetchGuestAutoSuggest.rejected, (state, action) => {
            state.boolkingFetchGuestAutoSuggestLoading = 'failed';
        });

        builder.addCase(fetchBoolkingFetchBusinessProviderByProfitCenter.fulfilled, (state, action) => {
            state.boolkingFetchBusinessByProfitCenterLoading = 'succeeded';
            state.boolkingFetchBusinessProviderByProfitCenter = action.payload.data;
          });
        builder.addCase(fetchBoolkingFetchBusinessProviderByProfitCenter.pending, (state, action) => {
            state.boolkingFetchBusinessByProfitCenterLoading = 'loading';   
            });
        builder.addCase(fetchBoolkingFetchBusinessProviderByProfitCenter.rejected, (state, action) => {
            state.boolkingFetchBusinessByProfitCenterLoading = 'failed';
        });


        
        
    },
})


export const { createbookinguiformupdate,createbookinguiformreset, completeReset, submitformdata,  removefromlist, bookingListSearch } = bookingSlice.actions
export default bookingSlice.reducer